export default __webpack_public_path__ + "static/virtual-tour-featured-image-0e38537db7e34bdb64db3fdc851bda9b.png";